<template>
  <div class="sino-card welfareNew" v-loading.fullscreen.lock="loading">
    <!-- 头部开始 -->
    <topPart :rightPart="true">
      <template slot="difinePort">
        <!-- 选择器 -->
        <div class="opentionStyle" style="flex: 1;">
          <van-dropdown-menu active-color="#38c7c4">
            <van-dropdown-item
              height="20"
              v-model="typeFlag"
              :options="typeList"
              @change="onFilter()"
            />
          </van-dropdown-menu>
        </div>
        <!-- 选择器结束 -->
      </template>
    </topPart>
    <!-- 头部结束 -->
    <div v-if="test" style="position:fixed;top:0;z-index:9999">
      <signature @closePop="closePop" @saveImg="complete"></signature>
    </div>
    <div class="list-block" v-infinite-scroll="loadMore" infinite-scroll-distance="50">
      <div class="card-box" v-for="item in condoleList" :key="item.id">
        <!-- 名称列表 -->
        <div class="list-name-title">
          <span class="nameTitleStyle">{{loginInfo.name}}</span>
          <span class="departmentStyle">{{loginInfo.deptName}}</span>
        </div>
        <!-- 内容列表 -->
        <div class="rowBox" v-for="(objConfig,index) in getArrCondfig(item)" :key="index">
          <div class="rowBoxTitle">{{strategyFunction(objConfig,item)}}</div>
          <span
            class="type-img-box"
            :class="{'rowBoxConter contentColor':addColor(objConfig.title)}"
          >{{strategy(objConfig,item)}}</span>

          <div class="imgBoxStype" v-if="typeImgUrl(objConfig,item)">
            <img class="imgStype" src="@/images/declare.png" />
          </div>
        </div>
        <!-- 领用人签字盒子 -->
        <div class="row sign-up">
          <p class="title">领用人签字</p>

          <div v-if="item.receiverSign" class="resign">
            <img class="sign-img" :src="item.receiverSign" />
            <span
              @click="showPopup(item.id)"
              v-if="autographTransfrom(item.comfortType)"
              class="resign-txt"
            >重新签名</span>
          </div>
          <div class="sign-btn-box" v-else>
            <el-button
              v-if="autographTransfrom(item.comfortType)"
              class="sign-btn"
              @click="showPopup(item.id)"
            >
              <img class="img" src="../../assets/images/icon-sign.png" />签名
            </el-button>
          </div>
        </div>
        <!-- 领用人签字盒子结束 -->
      </div>
      <p class="nomore" v-if="noMore">没有更多了</p>

      <div v-if="condoleList.length == 0" class="blank">
        <img src="@/images/404-02.png" alt />
      </div>
    </div>
  </div>
</template>

<script>
import signature from "../../components/signature.vue";
import { toast } from "@/common/api/api.js";
import { myComforts, getWXInfo, signinHonoreeSignature } from "@/common/api";
import topPart from "../../components/topPart";
export default {
  components: { signature, topPart },
  data() {
    return {
      routerObj: {
        router: "/personalCenter",
      },
      secondaryType: {},
      deathType: {},
      typeTransfromOther: {},
      configObje: {
        1: [
          {
            key: "",
            title: "申请类型",
            fun: "type",
          },
          {
            key: "secondaryType",
            title: "住院类型",
            isImg: true,
            fun: "typeTransfrom",
          },
          {
            key: "dataApplication",
            title: "住院日期",
            fun: "ordinary",
          },
          {
            key: "applyDateStr",
            title: "申请日期",
            fun: "ordinary",
          },
          {
            key: "reason",
            title: "住院事由",
            fun: "ordinary",
          },
        ],
        2: [
          {
            key: "",
            title: "申请类型",
            fun: "type",
          },
          {
            keyTwo: "money",
            key: "goods",
            title: "申请补助物品",
            titleTwo: "申请补助金额",
            fun: "ordinaryMoneyOrGoods",
            titleFun:true,
          },
          {
            key: "secondaryType",
            title: "申请补助事由",
            fun: "typeTransfromDeath",
          },
          {
            key: "applyDateStr",
            title: "申请日期",
            fun: "ordinary",
          },
        ],
        3: [
          {
            key: "",
            title: "申请类型",
            fun: "type",
          },
          {
            key: "reason",
            title: "申请原因及现状",
            fun: "ordinary",
          },
          {
            key: "applyDateStr",
            title: "申请日期",
            fun: "ordinary",
          },
        ],
        4: [
          {
            key: "",
            title: "申请类型",
            fun: "type",
          },
          {
            key: "sex",
            title: "性别",
            fun: "typeTransfromSex",
          },
          {
            key: "age",
            title: "年龄",
            fun: "ordinary",
          },
          {
            key: "money",
            title: "申请补助金额",
            fun: "ordinary",
          },
          {
            key: "approvedAmount",
            title: "批准补助金额",
            fun: "ordinary",
          },
          {
            key: "reason",
            title: "申请补助原因",
            fun: "ordinary",
          },
          {
            key: "applyDateStr",
            title: "申请日期",
            fun: "ordinary",
          },
        ],
        5: [
          {
            key: "",
            title: "申请类型",
            fun: "type",
          },
          {
            key: "secondaryType",
            title: "慰问类型",
            fun: "typeTransfromOthers",
          },
          {
            key: "reason",
            title: "申请原因及现状",
            fun: "ordinary",
          },
          {
            key: "applyDateStr",
            title: "申请日期",
            fun: "ordinary",
          },
        ],
      },
      typeObj: {
        1: "住院慰问申请",
        2: "亲属去世申请",
        3: "大病救助申请",
        4: "困难补助申请",
        5: "其他慰问申请",
      },
      typeFlag: 0, //分会选择标识
      typeList: [
        { text: "全部", value: 0 },
        { text: "住院慰问", value: 1 },
        { text: "亲属去世", value: 2 },
        { text: "大病救助", value: 3 },
        { text: "其他慰问", value: 5 },
        { text: "困难补助", value: 4 },
      ], //
      autograph: {}, //签名标识
      condoleList: [],
      loading: false,
      currentPage: 0,
      pageSize: 10,
      loginInfo: "",
      test: false,
      noMore: false,
      imgData: "",
      selId: "",
      orderNumber:""
    };
  },
  created() {
    this.loginInfo = JSON.parse(window.localStorage.getItem("loginInfo"));
    
    //获取签名标识
    this.getAutograph();

    //获取申请补助事由
    this.getReasonsForSubsidy();
  },
  mounted() {
    this.getConfigData();
    this.orderNumber = this.$route.query.orderNumber?this.$route.query.orderNumber:location.search.split('=')[1]  //从推送直接跳转到此页面，获取列表需要传递的参数
    console.log('orderNumber123',this.orderNumber)
    //this.getCondoleList();
  },
  methods: {
    //标题转换函数
    strategyFunction(obj, item) {
      if (obj.titleFun) {
        if(item[obj.key]){
            return obj.title;
        }else{
            return obj.titleTwo;
        }
      } else {
        return obj.title;
      }
    },
    //金额物品转换器
    ordinaryMoneyOrGoods(obj, item){
      if(item[obj.key]){
        return item[obj.key];
      }else{
        return item[obj.keyTwo];
      }
    },
    //获取参数
    getReasonsForSubsidyData() {
      var obj = {
        dictType: "hospitalization",
      };
      return obj;
    },
    //获取住院类型审核
    getReasonsForSubsidy() {
      var obj = this.getReasonsForSubsidyData();
      this.centralControl.axios.centralControl(
        "getUserDictValueAllData",
        (res) => {
          const { code, data, message } = res;
          if (code == 200) {
            for (var a = 0; a < data.length; a++) {
              this.secondaryType[data[a].dictValue] = data[a].dictLabel;
            }
          }
        },
        obj
      );
    },
    typeTransfromSex(item, obj) {
      var sex = obj[item.key];
      if (sex == "2") {
        return "女";
      } else if (sex == "1") {
        return "男";
      } else {
        return sex;
      }
    },
    //是否展示签名判断
    autographTransfrom(contentType) {
      if (this.autograph[contentType] == 1) {
        return true;
      }
      return false;
    },
    //签名标识 转换函数
    transfromAutograph(arr) {
      for (var a = 0; a < arr.length; a++) {
        this.autograph[arr[a].flag] = arr[a].signatureIdentification;
      }
    },
    //获取审批签名开关
    getAutograph() {
      this.centralControl.axios.centralControl("getAutograph", (res) => {
        const { code, data, message } = res;
        if (code == 200) {
          this.transfromAutograph(data);
        }
      });
    },
    // 添加color
    addColor(data) {
      return data === "申请类型" ? true : false;
    },
    getConfigData() {
      var obj = this.centralControl.utils.getConfig(
        this.centralControl.config,
        ["sympathy"]
      );
      //获取申请补助事由
      // var arr = this.centralControl.utils.getConfig(obj, [
      //   "hospitalization",
      //   "hospitalizationType",
      // ]);

      //获取配置对象
      var configObj = this.centralControl.utils.getConfig(obj, ["death"]);
      //获取类型
      this.transfromDeathType(
        this.deathType,
        configObj.deathType,
        "value",
        "label"
      );

      //获取配置对象
      var configObj = this.centralControl.utils.getConfig(obj, ["sympathy"]);

      //获取类型
      this.transfromDeathType(
        this.typeTransfromOther,
        configObj.sympathyType,
        "value",
        "label"
      );

      // for (var a = 0; a < arr.length; a++) {
      //   this.secondaryType[arr[a].value] = arr[a].label;
      // }
    },
    //类型转换器
    transfromDeathType(obj, arr, key, value) {
      for (var a = 0; a < arr.length; a++) {
        obj[arr[a][key]] = arr[a][value];
      }
    },
    //事由转换器
    typeTransfromOthers(item, obj) {
      return this.typeTransfromOther[obj[item.key]];
    },
    typeTransfrom(item, obj) {
      return this.secondaryType[obj[item.key]];
    },
    //事由转换器
    typeTransfromDeath(item, obj) {
      if (obj.reason != "") {
        return obj.reason;
      }
      return this.deathType[obj[item.key]];
    },
    checkAgrn(obj) {
      if ("1,2,3".indexOf(obj.state + "") != -1) {
        return true;
      } else {
        return false;
      }
    },
    //图片校验
    typeImgUrl(item, obj) {
      if (item.isImg) {
        if (obj[item.key] == 2) {
          if (obj.allowance == 1) {
            return true;
          }
        }
      }
      return false;
    },
    type(con, obj) {
      return this.typeObj[obj.comfortType];
    },
    //策略函数
    strategy(item, obj) {
      return this[item.fun](item, obj);
    },
    //普通函数
    ordinary(item, obj) {
      return obj[item.key];
    },
    //获取配置
    getArrCondfig(obj) {
      return this.configObje[obj.comfortType];
    },
    //根据对象的key获取对象的值
    getObjAsKey(obj, key) {
      return obj[key];
    },
    onFilter() {
      this.condoleList = [];
      this.currentPage = 1;
      this.getCondoleList();
    },
    getCondoleList() {
      this.loading = true;
      var obj = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        nameId: this.loginInfo.id,
        comfortType: this.typeFlag,
        orderNumber:this.orderNumber || ''
      };
      this.centralControl.axios.centralControl(
        "myComforts",
        (res) => {
          if (res.code == 200) {
            this.loading = false;
            this.condoleList = [...this.condoleList, ...res.data];
            if (this.condoleList.length > 0 && res.data.length == 0) {
              this.noMore = true;
              return;
            }
          } else {
            this.loading = false;
            toast(this, res.message, "error");
          }
        },
        obj
      );
    },
    enterPage() {
      this.$router.push("/condoleApply");
    },
    complete(data) {
      if (data) {
        this.imgData = data;
        var obj = {
          nameId: this.loginInfo.id,
          receiverSign: data,
          id: this.selId,
          comfortType: this.typeFlag,
        };
        this.centralControl.axios.centralControl(
          "saveSignature",
          (res) => {
            if (res.code == 200) {
              this.currentPage = 1;
              this.condoleList = [];
              this.getCondoleList();
            } else {
              toast(this, res.message, "error");
              this.loading = false;
            }
          },
          obj
        );
      }
      this.test = false;
    },
    showPopup(itemId) {
      this.test = !this.test;
      this.selId = itemId;
    },
    closePop() {
      this.test = false;
    },
    loadMore() {
      this.currentPage++;
      this.getCondoleList();
    },
  },
};
</script>

<style lang="stylus" type="stylesheet/stylus" scoped>
@import '../../assets/stylus/theme.styl';
@import '../../assets/stylus/common.styl';

.sign-btn-box {
  width: 100%;
}

.rowBoxConter {
  display: inline-block;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: $text-gray;
}

.type-img-box {
  display: flex;
  flex: 1;
  align-items: center;
  padding-left: 10px;
  font-size: 14px;
}

.rowBoxTitle {
  width: 25%;
  display: inline-block;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: $text-black;
}

.rowBox {
  padding: 0 15px;
  line-height: 32px;
  display: flex;
}

.opentionStyle {
  overflow: hidden;
}

.imgBoxStype {
  display: flex;
  justify-content: center;
  align-content: center;
  width: 30%;
  height: 25px;
}

.contentColor {
  color: $default-color !important;
}

.top-box {
  box-shadow: none;
}

.list-name-title {
  display: flex;
  align-items: center;
  height: 30px;
  padding: 12px 15px 8px;
  border-bottom: 1px solid #EFEFF4;
  margin-bottom: 5px;
}

.departmentStyle {
  font-size: 14px;
  font-family: PingFang S;
  font-weight: 500;
  color: rgba(53, 53, 53, 1);
  margin-left: 10px;
}

.imgStype {
  width: 100%;
}

.sino-card {
  overflow: scroll;

  .nomore {
    font-size: 12px;
    padding-bottom: 10px;
    text-align: center;
    color: #808080;
  }

  .list-block {
    myContent();
    top: 45px;
    height: auto;
  }

  .btn-block {
    margin: 15px 0;

    .btn {
      border: none;
      background: rgba(56, 199, 196, 1);
      border-radius: 8px;
      color: #fff;
    }
  }

  .card-box {
    padding: 0;
    border-bottom: 1px solid #F4F4F7;
    margin-top: 10px;

    .nameTitleStyle {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: bold;
      color: rgba(53, 53, 53, 1);
      letter-spacing: 1px;
    }

    .row {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      display: flex;
      padding: 0 15px;

      p {
        width: 50%;
        padding: 5px 0;

        .title {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: $text-black;
        }

        .content {
          flex: 1;
          padding-left: 15px;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: rgba(136, 136, 136, 1);
        }
      }

      p.reason {
        width: 100%;
        display: flex;

        .content {
          font-size: 14px;
          color: rgba(136, 136, 136, 1);
          line-height: 18px;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
    }

    .sign-up {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      padding: 10px 10px;

      .resign {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex: 1;

        .sign-img {
          width: 40px;
          height: 28px;
          transform: rotate(69deg);
        }

        .resign-txt {
          color: $default-color;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: bold;
          font-style: normal;
        }
      }

      p {
        width: 100px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: $text-black;
      }

      .sign-btn {
        flex: 1;
        color: #38c7c4;
        border: 1px solid $default-color;
        background-color: #fff;
        width: 100%;

        .img {
          width: 18px;
          height: 18px;
          margin-right: 5px;
          vertical-align: sub;
        }
      }

      .el-button:active {
        color: $default-color;
        border-color: $default-color;
        outline: 0;
      }
    }
  }
}
</style>